// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

export const isFrequencyCappingCoverageChannel = objectOf({
  channel: string,
  channel_covered: boolean,
  fully_covered: boolean,
});

export const isGetMessagePrioritizationFrequencyCappingCoverageResult = objectOf({
  has_frequency_capping_rules: boolean,
  channels: arrayOf(isFrequencyCappingCoverageChannel),
});
